var countries ={
  countries: {
    2: {
    txt_id: "af",
    name: "Afghanistan",
    capital: "Kabul",
    Continent: "AS",
    top_level_domain: ".af",
    calling_code: "93",
    currency_code: "AFN",
    currency_name: "Afghani"
    },
    3: {
    txt_id: "al",
    name: "Albania",
    capital: "Tirana",
    Continent: "EU",
    top_level_domain: ".al",
    calling_code: "355",
    currency_code: "ALL",
    currency_name: "Lek"
    },
    4: {
    txt_id: "dz",
    name: "Algeria",
    capital: "Algiers",
    Continent: "AF",
    top_level_domain: ".dz",
    calling_code: "213",
    currency_code: "DZD",
    currency_name: "Algerian Dinar"
    },
    5: {
    txt_id: "as",
    name: "American Samoa",
    capital: "Pago Pago",
    Continent: "OC",
    top_level_domain: ".as",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    6: {
    txt_id: "ad",
    name: "Andorra",
    capital: "Andorra la Vella",
    Continent: "EU",
    top_level_domain: ".ad",
    calling_code: "376",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    7: {
    txt_id: "ao",
    name: "Angola",
    capital: "Luanda",
    Continent: "AF",
    top_level_domain: ".ao",
    calling_code: "244",
    currency_code: "AOA",
    currency_name: "Kwanza"
    },
    8: {
    txt_id: "ai",
    name: "Anguilla",
    capital: "The Valley",
    Continent: "NA",
    top_level_domain: ".ai",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    9: {
    txt_id: "aq",
    name: "Antarctica",
    capital: "",
    Continent: "AN",
    top_level_domain: ".aq",
    calling_code: "672",
    currency_code: "",
    currency_name: ""
    },
    10: {
    txt_id: "ag",
    name: "Antigua & Barbuda",
    capital: "St. John's",
    Continent: "NA",
    top_level_domain: ".ag",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    11: {
    txt_id: "ar",
    name: "Argentina",
    capital: "Buenos Aires",
    Continent: "SA",
    top_level_domain: ".ar",
    calling_code: "54",
    currency_code: "ARS",
    currency_name: "Argentine Peso"
    },
    12: {
    txt_id: "am",
    name: "Armenia",
    capital: "Yerevan",
    Continent: "AS",
    top_level_domain: ".am",
    calling_code: "374",
    currency_code: "AMD",
    currency_name: "Armenian Dram"
    },
    13: {
    txt_id: "aw",
    name: "Aruba",
    capital: "Oranjestad",
    Continent: "NA",
    top_level_domain: ".aw",
    calling_code: "297",
    currency_code: "AWG",
    currency_name: "Aruban Florin"
    },
    14: {
    txt_id: "au",
    name: "Australia",
    capital: "Canberra",
    Continent: "OC",
    top_level_domain: ".au",
    calling_code: "61",
    currency_code: "AUD",
    currency_name: "Australian Dollar"
    },
    15: {
    txt_id: "at",
    name: "Austria",
    capital: "Vienna",
    Continent: "EU",
    top_level_domain: ".at",
    calling_code: "43",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    16: {
    txt_id: "az",
    name: "Azerbaijan",
    capital: "Baku",
    Continent: "AS",
    top_level_domain: ".az",
    calling_code: "994",
    currency_code: "AZN",
    currency_name: "Azerbaijanian Manat"
    },
    17: {
    txt_id: "bs",
    name: "Bahamas",
    capital: "Nassau",
    Continent: "NA",
    top_level_domain: ".bs",
    calling_code: "1",
    currency_code: "BSD",
    currency_name: "Bahamian Dollar"
    },
    18: {
    txt_id: "bh",
    name: "Bahrain",
    capital: "Manama",
    Continent: "AS",
    top_level_domain: ".bh",
    calling_code: "973",
    currency_code: "BHD",
    currency_name: "Bahraini Dinar"
    },
    19: {
    txt_id: "bd",
    name: "Bangladesh",
    capital: "Dhaka",
    Continent: "AS",
    top_level_domain: ".bd",
    calling_code: "880",
    currency_code: "BDT",
    currency_name: "Taka"
    },
    20: {
    txt_id: "bb",
    name: "Barbados",
    capital: "Bridgetown",
    Continent: "NA",
    top_level_domain: ".bb",
    calling_code: "1",
    currency_code: "BBD",
    currency_name: "Barbados Dollar"
    },
    21: {
    txt_id: "by",
    name: "Belarus",
    capital: "Minsk",
    Continent: "EU",
    top_level_domain: ".by",
    calling_code: "375",
    currency_code: "BYR",
    currency_name: "Belarussian Ruble"
    },
    22: {
    txt_id: "be",
    name: "Belgium",
    capital: "Brussels",
    Continent: "EU",
    top_level_domain: ".be",
    calling_code: "32",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    23: {
    txt_id: "bz",
    name: "Belize",
    capital: "Belmopan",
    Continent: "NA",
    top_level_domain: ".bz",
    calling_code: "501",
    currency_code: "BZD",
    currency_name: "Belize Dollar"
    },
    24: {
    txt_id: "bj",
    name: "Benin",
    capital: "Porto-Novo",
    Continent: "AF",
    top_level_domain: ".bj",
    calling_code: "229",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    25: {
    txt_id: "bm",
    name: "Bermuda",
    capital: "Hamilton",
    Continent: "NA",
    top_level_domain: ".bm",
    calling_code: "1",
    currency_code: "BMD",
    currency_name: "Bermudian Dollar"
    },
    26: {
    txt_id: "bt",
    name: "Bhutan",
    capital: "Thimphu",
    Continent: "AS",
    top_level_domain: ".bt",
    calling_code: "975",
    currency_code: "INR",
    currency_name: "Indian Rupee"
    },
    27: {
    txt_id: "bo",
    name: "Bolivia",
    capital: "Sucre",
    Continent: "SA",
    top_level_domain: ".bo",
    calling_code: "591",
    currency_code: "BOB",
    currency_name: "Boliviano"
    },
    28: {
    txt_id: "ba",
    name: "Bosnia",
    capital: "Sarajevo",
    Continent: "EU",
    top_level_domain: ".ba",
    calling_code: "387",
    currency_code: "BAM",
    currency_name: "Convertible Mark"
    },
    29: {
    txt_id: "bw",
    name: "Botswana",
    capital: "Gaborone",
    Continent: "AF",
    top_level_domain: ".bw",
    calling_code: "267",
    currency_code: "BWP",
    currency_name: "Pula"
    },
    30: {
    txt_id: "bv",
    name: "Bouvet Island",
    capital: "",
    Continent: "AN",
    top_level_domain: ".bv",
    calling_code: "47",
    currency_code: "",
    currency_name: ""
    },
    31: {
    txt_id: "br",
    name: "Brazil",
    capital: "Brasilia",
    Continent: "SA",
    top_level_domain: ".br",
    calling_code: "55",
    currency_code: "BRL",
    currency_name: "Brazilian Real"
    },
    32: {
    txt_id: "io",
    name: "British Indian Ocean Territory",
    capital: "Diego Garcia",
    Continent: "AS",
    top_level_domain: ".io",
    calling_code: "246",
    currency_code: "",
    currency_name: ""
    },
    33: {
    txt_id: "vg",
    name: "British Virgin Islands",
    capital: "Road Town",
    Continent: "NA",
    top_level_domain: ".vg",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    34: {
    txt_id: "bn",
    name: "Brunei",
    capital: "Bandar Seri Begawan",
    Continent: "AS",
    top_level_domain: ".bn",
    calling_code: "673",
    currency_code: "BND",
    currency_name: "Brunei Dollar"
    },
    35: {
    txt_id: "bg",
    name: "Bulgaria",
    capital: "Sofia",
    Continent: "EU",
    top_level_domain: ".bg",
    calling_code: "359",
    currency_code: "BGN",
    currency_name: "Bulgarian Lev"
    },
    36: {
    txt_id: "bf",
    name: "Burkina Faso",
    capital: "Ouagadougou",
    Continent: "AF",
    top_level_domain: ".bf",
    calling_code: "226",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    37: {
    txt_id: "bi",
    name: "Burundi",
    capital: "Bujumbura",
    Continent: "AF",
    top_level_domain: ".bi",
    calling_code: "257",
    currency_code: "BIF",
    currency_name: "Burundi Franc"
    },
    38: {
    txt_id: "kh",
    name: "Cambodia",
    capital: "Phnom Penh",
    Continent: "AS",
    top_level_domain: ".kh",
    calling_code: "855",
    currency_code: "KHR",
    currency_name: "Riel"
    },
    39: {
    txt_id: "cm",
    name: "Cameroon",
    capital: "Yaounde",
    Continent: "AF",
    top_level_domain: ".cm",
    calling_code: "237",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    40: {
    txt_id: "ca",
    name: "Canada",
    capital: "Ottawa",
    Continent: "NA",
    top_level_domain: ".ca",
    calling_code: "1",
    currency_code: "CAD",
    currency_name: "Canadian Dollar",
    states: [
    {
    txt_id: "AB",
    name: "Alberta"
    },
    {
    txt_id: "BC",
    name: "British Columbia"
    },
    {
    txt_id: "MB",
    name: "Manitoba"
    },
    {
    txt_id: "NB",
    name: "New Brunswick"
    },
    {
    txt_id: "NL",
    name: "Newfoundland and Labrador"
    },
    {
    txt_id: "NT",
    name: "Northwest Territories"
    },
    {
    txt_id: "NS",
    name: "Nova Scotia"
    },
    {
    txt_id: "NU",
    name: "Nunavut"
    },
    {
    txt_id: "ON",
    name: "Ontario"
    },
    {
    txt_id: "PE",
    name: "Prince Edward Island"
    },
    {
    txt_id: "QC",
    name: "Quebec"
    },
    {
    txt_id: "SK",
    name: "Saskatchewan"
    },
    {
    txt_id: "YT",
    name: "Yukon Territory"
    }
    ]
    },
    41: {
    txt_id: "cv",
    name: "Cape Verde",
    capital: "Praia",
    Continent: "AF",
    top_level_domain: ".cv",
    calling_code: "238",
    currency_code: "CVE",
    currency_name: "Cabo Verde Escudo"
    },
    42: {
    txt_id: "bq",
    name: "Caribbean Netherlands",
    capital: "",
    Continent: "NA",
    top_level_domain: ".bq",
    calling_code: "599",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    43: {
    txt_id: "ky",
    name: "Cayman Islands",
    capital: "George Town",
    Continent: "NA",
    top_level_domain: ".ky",
    calling_code: "1",
    currency_code: "KYD",
    currency_name: "Cayman Islands Dollar"
    },
    44: {
    txt_id: "cf",
    name: "Central African Republic",
    capital: "Bangui",
    Continent: "AF",
    top_level_domain: ".cf",
    calling_code: "236",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    45: {
    txt_id: "td",
    name: "Chad",
    capital: "N'Djamena",
    Continent: "AF",
    top_level_domain: ".td",
    calling_code: "235",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    46: {
    txt_id: "cl",
    name: "Chile",
    capital: "Santiago",
    Continent: "SA",
    top_level_domain: ".cl",
    calling_code: "56",
    currency_code: "CLP",
    currency_name: "Chilean Peso"
    },
    47: {
    txt_id: "cn",
    name: "China",
    capital: "Beijing",
    Continent: "AS",
    top_level_domain: ".cn",
    calling_code: "86",
    currency_code: "CNY",
    currency_name: "Yuan Renminbi"
    },
    48: {
    txt_id: "cx",
    name: "Christmas Island",
    capital: "Flying Fish Cove",
    Continent: "AS",
    top_level_domain: ".cx",
    calling_code: "61",
    currency_code: "",
    currency_name: ""
    },
    49: {
    txt_id: "cc",
    name: "Cocos (Keeling) Islands",
    capital: "West Island",
    Continent: "AS",
    top_level_domain: ".cc",
    calling_code: "61",
    currency_code: "",
    currency_name: ""
    },
    50: {
    txt_id: "co",
    name: "Colombia",
    capital: "Bogota",
    Continent: "SA",
    top_level_domain: ".co",
    calling_code: "57",
    currency_code: "COP",
    currency_name: "Colombian Peso"
    },
    51: {
    txt_id: "km",
    name: "Comoros",
    capital: "Moroni",
    Continent: "AF",
    top_level_domain: ".km",
    calling_code: "269",
    currency_code: "KMF",
    currency_name: "Comoro Franc"
    },
    52: {
    txt_id: "cg",
    name: "Congo - Brazzaville",
    capital: "Brazzaville",
    Continent: "AF",
    top_level_domain: ".cg",
    calling_code: "242",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    53: {
    txt_id: "cd",
    name: "Congo - Kinshasa",
    capital: "Kinshasa",
    Continent: "AF",
    top_level_domain: ".cd",
    calling_code: "243",
    currency_code: "",
    currency_name: ""
    },
    54: {
    txt_id: "ck",
    name: "Cook Islands",
    capital: "Avarua",
    Continent: "OC",
    top_level_domain: ".ck",
    calling_code: "682",
    currency_code: "NZD",
    currency_name: "New Zealand Dollar"
    },
    55: {
    txt_id: "cr",
    name: "Costa Rica",
    capital: "San Jose",
    Continent: "NA",
    top_level_domain: ".cr",
    calling_code: "506",
    currency_code: "CRC",
    currency_name: "Costa Rican Colon"
    },
    56: {
    txt_id: "hr",
    name: "Croatia",
    capital: "Zagreb",
    Continent: "EU",
    top_level_domain: ".hr",
    calling_code: "385",
    currency_code: "HRK",
    currency_name: "Croatian Kuna"
    },
    57: {
    txt_id: "cu",
    name: "Cuba",
    capital: "Havana",
    Continent: "NA",
    top_level_domain: ".cu",
    calling_code: "53",
    currency_code: "CUP",
    currency_name: "Cuban Peso"
    },
    58: {
    txt_id: "cw",
    name: "Curaçao",
    capital: "Willemstad",
    Continent: "NA",
    top_level_domain: ".cw",
    calling_code: "599",
    currency_code: "ANG",
    currency_name: "Netherlands Antillean Guilder"
    },
    59: {
    txt_id: "cy",
    name: "Cyprus",
    capital: "Nicosia",
    Continent: "EU",
    top_level_domain: ".cy",
    calling_code: "357",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    60: {
    txt_id: "cz",
    name: "Czechia",
    capital: "Prague",
    Continent: "EU",
    top_level_domain: ".cz",
    calling_code: "420",
    currency_code: "CZK",
    currency_name: "Czech Koruna"
    },
    61: {
    txt_id: "ci",
    name: "Côte d’Ivoire",
    capital: "Yamoussoukro",
    Continent: "AF",
    top_level_domain: ".ci",
    calling_code: "225",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    62: {
    txt_id: "dk",
    name: "Denmark",
    capital: "Copenhagen",
    Continent: "EU",
    top_level_domain: ".dk",
    calling_code: "45",
    currency_code: "DKK",
    currency_name: "Danish Krone"
    },
    63: {
    txt_id: "dj",
    name: "Djibouti",
    capital: "Djibouti",
    Continent: "AF",
    top_level_domain: ".dj",
    calling_code: "253",
    currency_code: "DJF",
    currency_name: "Djibouti Franc"
    },
    64: {
    txt_id: "dm",
    name: "Dominica",
    capital: "Roseau",
    Continent: "NA",
    top_level_domain: ".dm",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    65: {
    txt_id: "do",
    name: "Dominican Republic",
    capital: "Santo Domingo",
    Continent: "NA",
    top_level_domain: ".do",
    calling_code: "1",
    currency_code: "DOP",
    currency_name: "Dominican Peso"
    },
    66: {
    txt_id: "ec",
    name: "Ecuador",
    capital: "Quito",
    Continent: "SA",
    top_level_domain: ".ec",
    calling_code: "593",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    67: {
    txt_id: "eg",
    name: "Egypt",
    capital: "Cairo",
    Continent: "AF",
    top_level_domain: ".eg",
    calling_code: "20",
    currency_code: "EGP",
    currency_name: "Egyptian Pound"
    },
    68: {
    txt_id: "sv",
    name: "El Salvador",
    capital: "San Salvador",
    Continent: "NA",
    top_level_domain: ".sv",
    calling_code: "503",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    69: {
    txt_id: "gq",
    name: "Equatorial Guinea",
    capital: "Malabo",
    Continent: "AF",
    top_level_domain: ".gq",
    calling_code: "240",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    70: {
    txt_id: "er",
    name: "Eritrea",
    capital: "Asmara",
    Continent: "AF",
    top_level_domain: ".er",
    calling_code: "291",
    currency_code: "ERN",
    currency_name: "Nakfa"
    },
    71: {
    txt_id: "ee",
    name: "Estonia",
    capital: "Tallinn",
    Continent: "EU",
    top_level_domain: ".ee",
    calling_code: "372",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    72: {
    txt_id: "et",
    name: "Ethiopia",
    capital: "Addis Ababa",
    Continent: "AF",
    top_level_domain: ".et",
    calling_code: "251",
    currency_code: "ETB",
    currency_name: "Ethiopian Birr"
    },
    73: {
    txt_id: "fk",
    name: "Falkland Islands",
    capital: "Stanley",
    Continent: "SA",
    top_level_domain: ".fk",
    calling_code: "500",
    currency_code: "FKP",
    currency_name: "Falkland Islands Pound"
    },
    74: {
    txt_id: "fo",
    name: "Faroe Islands",
    capital: "Torshavn",
    Continent: "EU",
    top_level_domain: ".fo",
    calling_code: "298",
    currency_code: "",
    currency_name: ""
    },
    75: {
    txt_id: "fj",
    name: "Fiji",
    capital: "Suva",
    Continent: "OC",
    top_level_domain: ".fj",
    calling_code: "679",
    currency_code: "FJD",
    currency_name: "Fiji Dollar"
    },
    76: {
    txt_id: "fi",
    name: "Finland",
    capital: "Helsinki",
    Continent: "EU",
    top_level_domain: ".fi",
    calling_code: "358",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    77: {
    txt_id: "fr",
    name: "France",
    capital: "Paris",
    Continent: "EU",
    top_level_domain: ".fr",
    calling_code: "33",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    78: {
    txt_id: "gf",
    name: "French Guiana",
    capital: "Cayenne",
    Continent: "SA",
    top_level_domain: ".gf",
    calling_code: "594",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    79: {
    txt_id: "pf",
    name: "French Polynesia",
    capital: "Papeete",
    Continent: "OC",
    top_level_domain: ".pf",
    calling_code: "689",
    currency_code: "XPF",
    currency_name: "CFP Franc"
    },
    80: {
    txt_id: "tf",
    name: "French Southern Territories",
    capital: "Port-aux-Francais",
    Continent: "AN",
    top_level_domain: ".tf",
    calling_code: "262",
    currency_code: "",
    currency_name: ""
    },
    81: {
    txt_id: "ga",
    name: "Gabon",
    capital: "Libreville",
    Continent: "AF",
    top_level_domain: ".ga",
    calling_code: "241",
    currency_code: "XAF",
    currency_name: "CFA Franc BEAC"
    },
    82: {
    txt_id: "gm",
    name: "Gambia",
    capital: "Banjul",
    Continent: "AF",
    top_level_domain: ".gm",
    calling_code: "220",
    currency_code: "GMD",
    currency_name: "Dalasi"
    },
    83: {
    txt_id: "ge",
    name: "Georgia",
    capital: "Tbilisi",
    Continent: "AS",
    top_level_domain: ".ge",
    calling_code: "995",
    currency_code: "GEL",
    currency_name: "Lari"
    },
    84: {
    txt_id: "de",
    name: "Germany",
    capital: "Berlin",
    Continent: "EU",
    top_level_domain: ".de",
    calling_code: "49",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    85: {
    txt_id: "gh",
    name: "Ghana",
    capital: "Accra",
    Continent: "AF",
    top_level_domain: ".gh",
    calling_code: "233",
    currency_code: "GHS",
    currency_name: "Ghana Cedi"
    },
    86: {
    txt_id: "gi",
    name: "Gibraltar",
    capital: "Gibraltar",
    Continent: "EU",
    top_level_domain: ".gi",
    calling_code: "350",
    currency_code: "GIP",
    currency_name: "Gibraltar Pound"
    },
    87: {
    txt_id: "gr",
    name: "Greece",
    capital: "Athens",
    Continent: "EU",
    top_level_domain: ".gr",
    calling_code: "30",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    88: {
    txt_id: "gl",
    name: "Greenland",
    capital: "Nuuk",
    Continent: "NA",
    top_level_domain: ".gl",
    calling_code: "299",
    currency_code: "DKK",
    currency_name: "Danish Krone"
    },
    89: {
    txt_id: "gd",
    name: "Grenada",
    capital: "St. George's",
    Continent: "NA",
    top_level_domain: ".gd",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    90: {
    txt_id: "gp",
    name: "Guadeloupe",
    capital: "Basse-Terre",
    Continent: "NA",
    top_level_domain: ".gp",
    calling_code: "590",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    91: {
    txt_id: "gu",
    name: "Guam",
    capital: "Hagatna",
    Continent: "OC",
    top_level_domain: ".gu",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    92: {
    txt_id: "gt",
    name: "Guatemala",
    capital: "Guatemala City",
    Continent: "NA",
    top_level_domain: ".gt",
    calling_code: "502",
    currency_code: "GTQ",
    currency_name: "Quetzal"
    },
    93: {
    txt_id: "gg",
    name: "Guernsey",
    capital: "St Peter Port",
    Continent: "EU",
    top_level_domain: ".gg",
    calling_code: "44",
    currency_code: "GBP",
    currency_name: "Pound Sterling"
    },
    94: {
    txt_id: "gn",
    name: "Guinea",
    capital: "Conakry",
    Continent: "AF",
    top_level_domain: ".gn",
    calling_code: "224",
    currency_code: "GNF",
    currency_name: "Guinea Franc"
    },
    95: {
    txt_id: "gw",
    name: "Guinea-Bissau",
    capital: "Bissau",
    Continent: "AF",
    top_level_domain: ".gw",
    calling_code: "245",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    96: {
    txt_id: "gy",
    name: "Guyana",
    capital: "Georgetown",
    Continent: "SA",
    top_level_domain: ".gy",
    calling_code: "592",
    currency_code: "GYD",
    currency_name: "Guyana Dollar"
    },
    97: {
    txt_id: "ht",
    name: "Haiti",
    capital: "Port-au-Prince",
    Continent: "NA",
    top_level_domain: ".ht",
    calling_code: "509",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    98: {
    txt_id: "hm",
    name: "Heard & McDonald Islands",
    capital: "",
    Continent: "AN",
    top_level_domain: ".hm",
    calling_code: "672",
    currency_code: "",
    currency_name: ""
    },
    99: {
    txt_id: "hn",
    name: "Honduras",
    capital: "Tegucigalpa",
    Continent: "NA",
    top_level_domain: ".hn",
    calling_code: "504",
    currency_code: "HNL",
    currency_name: "Lempira"
    },
    100: {
    txt_id: "hk",
    name: "Hong Kong",
    capital: "Hong Kong",
    Continent: "AS",
    top_level_domain: ".hk",
    calling_code: "852",
    currency_code: "",
    currency_name: ""
    },
    101: {
    txt_id: "hu",
    name: "Hungary",
    capital: "Budapest",
    Continent: "EU",
    top_level_domain: ".hu",
    calling_code: "36",
    currency_code: "HUF",
    currency_name: "Forint"
    },
    102: {
    txt_id: "is",
    name: "Iceland",
    capital: "Reykjavik",
    Continent: "EU",
    top_level_domain: ".is",
    calling_code: "354",
    currency_code: "ISK",
    currency_name: "Iceland Krona"
    },
    103: {
    txt_id: "in",
    name: "India",
    capital: "New Delhi",
    Continent: "AS",
    top_level_domain: ".in",
    calling_code: "91",
    currency_code: "INR",
    currency_name: "Indian Rupee"
    },
    104: {
    txt_id: "id",
    name: "Indonesia",
    capital: "Jakarta",
    Continent: "AS",
    top_level_domain: ".id",
    calling_code: "62",
    currency_code: "IDR",
    currency_name: "Rupiah"
    },
    105: {
    txt_id: "ir",
    name: "Iran",
    capital: "Tehran",
    Continent: "AS",
    top_level_domain: ".ir",
    calling_code: "98",
    currency_code: "IRR",
    currency_name: "Iranian Rial"
    },
    106: {
    txt_id: "iq",
    name: "Iraq",
    capital: "Baghdad",
    Continent: "AS",
    top_level_domain: ".iq",
    calling_code: "964",
    currency_code: "IQD",
    currency_name: "Iraqi Dinar"
    },
    107: {
    txt_id: "ie",
    name: "Ireland",
    capital: "Dublin",
    Continent: "EU",
    top_level_domain: ".ie",
    calling_code: "353",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    108: {
    txt_id: "im",
    name: "Isle of Man",
    capital: "Douglas",
    Continent: "EU",
    top_level_domain: ".im",
    calling_code: "44",
    currency_code: "GBP",
    currency_name: "Pound Sterling"
    },
    109: {
    txt_id: "il",
    name: "Israel",
    capital: "Jerusalem",
    Continent: "AS",
    top_level_domain: ".il",
    calling_code: "972",
    currency_code: "ILS",
    currency_name: "New Israeli Sheqel"
    },
    110: {
    txt_id: "it",
    name: "Italy",
    capital: "Rome",
    Continent: "EU",
    top_level_domain: ".it",
    calling_code: "39",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    111: {
    txt_id: "jm",
    name: "Jamaica",
    capital: "Kingston",
    Continent: "NA",
    top_level_domain: ".jm",
    calling_code: "1",
    currency_code: "JMD",
    currency_name: "Jamaican Dollar"
    },
    112: {
    txt_id: "jp",
    name: "Japan",
    capital: "Tokyo",
    Continent: "AS",
    top_level_domain: ".jp",
    calling_code: "81",
    currency_code: "JPY",
    currency_name: "Yen"
    },
    113: {
    txt_id: "je",
    name: "Jersey",
    capital: "Saint Helier",
    Continent: "EU",
    top_level_domain: ".je",
    calling_code: "44",
    currency_code: "GBP",
    currency_name: "Pound Sterling"
    },
    114: {
    txt_id: "jo",
    name: "Jordan",
    capital: "Amman",
    Continent: "AS",
    top_level_domain: ".jo",
    calling_code: "962",
    currency_code: "JOD",
    currency_name: "Jordanian Dinar"
    },
    115: {
    txt_id: "kz",
    name: "Kazakhstan",
    capital: "Astana",
    Continent: "AS",
    top_level_domain: ".kz",
    calling_code: "7",
    currency_code: "KZT",
    currency_name: "Tenge"
    },
    116: {
    txt_id: "ke",
    name: "Kenya",
    capital: "Nairobi",
    Continent: "AF",
    top_level_domain: ".ke",
    calling_code: "254",
    currency_code: "KES",
    currency_name: "Kenyan Shilling"
    },
    117: {
    txt_id: "ki",
    name: "Kiribati",
    capital: "Tarawa",
    Continent: "OC",
    top_level_domain: ".ki",
    calling_code: "686",
    currency_code: "AUD",
    currency_name: "Australian Dollar"
    },
    118: {
    txt_id: "kw",
    name: "Kuwait",
    capital: "Kuwait City",
    Continent: "AS",
    top_level_domain: ".kw",
    calling_code: "965",
    currency_code: "KWD",
    currency_name: "Kuwaiti Dinar"
    },
    119: {
    txt_id: "kg",
    name: "Kyrgyzstan",
    capital: "Bishkek",
    Continent: "AS",
    top_level_domain: ".kg",
    calling_code: "996",
    currency_code: "KGS",
    currency_name: "Som"
    },
    120: {
    txt_id: "la",
    name: "Laos",
    capital: "Vientiane",
    Continent: "AS",
    top_level_domain: ".la",
    calling_code: "856",
    currency_code: "LAK",
    currency_name: "Kip"
    },
    121: {
    txt_id: "lv",
    name: "Latvia",
    capital: "Riga",
    Continent: "EU",
    top_level_domain: ".lv",
    calling_code: "371",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    122: {
    txt_id: "lb",
    name: "Lebanon",
    capital: "Beirut",
    Continent: "AS",
    top_level_domain: ".lb",
    calling_code: "961",
    currency_code: "LBP",
    currency_name: "Lebanese Pound"
    },
    123: {
    txt_id: "ls",
    name: "Lesotho",
    capital: "Maseru",
    Continent: "AF",
    top_level_domain: ".ls",
    calling_code: "266",
    currency_code: "ZAR",
    currency_name: "Rand"
    },
    124: {
    txt_id: "lr",
    name: "Liberia",
    capital: "Monrovia",
    Continent: "AF",
    top_level_domain: ".lr",
    calling_code: "231",
    currency_code: "LRD",
    currency_name: "Liberian Dollar"
    },
    125: {
    txt_id: "ly",
    name: "Libya",
    capital: "Tripoli",
    Continent: "AF",
    top_level_domain: ".ly",
    calling_code: "218",
    currency_code: "LYD",
    currency_name: "Libyan Dinar"
    },
    126: {
    txt_id: "li",
    name: "Liechtenstein",
    capital: "Vaduz",
    Continent: "EU",
    top_level_domain: ".li",
    calling_code: "423",
    currency_code: "CHF",
    currency_name: "Swiss Franc"
    },
    127: {
    txt_id: "lt",
    name: "Lithuania",
    capital: "Vilnius",
    Continent: "EU",
    top_level_domain: ".lt",
    calling_code: "370",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    128: {
    txt_id: "lu",
    name: "Luxembourg",
    capital: "Luxembourg",
    Continent: "EU",
    top_level_domain: ".lu",
    calling_code: "352",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    129: {
    txt_id: "mo",
    name: "Macau",
    capital: "Macao",
    Continent: "AS",
    top_level_domain: ".mo",
    calling_code: "853",
    currency_code: "MOP",
    currency_name: "Pataca"
    },
    130: {
    txt_id: "mk",
    name: "Macedonia",
    capital: "Skopje",
    Continent: "EU",
    top_level_domain: ".mk",
    calling_code: "389",
    currency_code: "MKD",
    currency_name: "Denar"
    },
    131: {
    txt_id: "mg",
    name: "Madagascar",
    capital: "Antananarivo",
    Continent: "AF",
    top_level_domain: ".mg",
    calling_code: "261",
    currency_code: "MGA",
    currency_name: "Malagasy Ariary"
    },
    132: {
    txt_id: "mw",
    name: "Malawi",
    capital: "Lilongwe",
    Continent: "AF",
    top_level_domain: ".mw",
    calling_code: "265",
    currency_code: "MWK",
    currency_name: "Kwacha"
    },
    133: {
    txt_id: "my",
    name: "Malaysia",
    capital: "Kuala Lumpur",
    Continent: "AS",
    top_level_domain: ".my",
    calling_code: "60",
    currency_code: "MYR",
    currency_name: "Malaysian Ringgit"
    },
    134: {
    txt_id: "mv",
    name: "Maldives",
    capital: "Male",
    Continent: "AS",
    top_level_domain: ".mv",
    calling_code: "960",
    currency_code: "MVR",
    currency_name: "Rufiyaa"
    },
    135: {
    txt_id: "ml",
    name: "Mali",
    capital: "Bamako",
    Continent: "AF",
    top_level_domain: ".ml",
    calling_code: "223",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    136: {
    txt_id: "mt",
    name: "Malta",
    capital: "Valletta",
    Continent: "EU",
    top_level_domain: ".mt",
    calling_code: "356",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    137: {
    txt_id: "mh",
    name: "Marshall Islands",
    capital: "Majuro",
    Continent: "OC",
    top_level_domain: ".mh",
    calling_code: "692",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    138: {
    txt_id: "mq",
    name: "Martinique",
    capital: "Fort-de-France",
    Continent: "NA",
    top_level_domain: ".mq",
    calling_code: "596",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    139: {
    txt_id: "mr",
    name: "Mauritania",
    capital: "Nouakchott",
    Continent: "AF",
    top_level_domain: ".mr",
    calling_code: "222",
    currency_code: "MRO",
    currency_name: "Ouguiya"
    },
    140: {
    txt_id: "mu",
    name: "Mauritius",
    capital: "Port Louis",
    Continent: "AF",
    top_level_domain: ".mu",
    calling_code: "230",
    currency_code: "MUR",
    currency_name: "Mauritius Rupee"
    },
    141: {
    txt_id: "yt",
    name: "Mayotte",
    capital: "Mamoudzou",
    Continent: "AF",
    top_level_domain: ".yt",
    calling_code: "262",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    142: {
    txt_id: "mx",
    name: "Mexico",
    capital: "Mexico City",
    Continent: "NA",
    top_level_domain: ".mx",
    calling_code: "52",
    currency_code: "MXN",
    currency_name: "Mexican Peso"
    },
    143: {
    txt_id: "fm",
    name: "Micronesia",
    capital: "Palikir",
    Continent: "OC",
    top_level_domain: ".fm",
    calling_code: "691",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    144: {
    txt_id: "md",
    name: "Moldova",
    capital: "Chisinau",
    Continent: "EU",
    top_level_domain: ".md",
    calling_code: "373",
    currency_code: "MDL",
    currency_name: "Moldovan Leu"
    },
    145: {
    txt_id: "mc",
    name: "Monaco",
    capital: "Monaco",
    Continent: "EU",
    top_level_domain: ".mc",
    calling_code: "377",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    146: {
    txt_id: "mn",
    name: "Mongolia",
    capital: "Ulan Bator",
    Continent: "AS",
    top_level_domain: ".mn",
    calling_code: "976",
    currency_code: "MNT",
    currency_name: "Tugrik"
    },
    147: {
    txt_id: "me",
    name: "Montenegro",
    capital: "Podgorica",
    Continent: "EU",
    top_level_domain: ".me",
    calling_code: "382",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    148: {
    txt_id: "ms",
    name: "Montserrat",
    capital: "Plymouth",
    Continent: "NA",
    top_level_domain: ".ms",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    149: {
    txt_id: "ma",
    name: "Morocco",
    capital: "Rabat",
    Continent: "AF",
    top_level_domain: ".ma",
    calling_code: "212",
    currency_code: "MAD",
    currency_name: "Moroccan Dirham"
    },
    150: {
    txt_id: "mz",
    name: "Mozambique",
    capital: "Maputo",
    Continent: "AF",
    top_level_domain: ".mz",
    calling_code: "258",
    currency_code: "MZN",
    currency_name: "Mozambique Metical"
    },
    151: {
    txt_id: "mm",
    name: "Myanmar",
    capital: "Nay Pyi Taw",
    Continent: "AS",
    top_level_domain: ".mm",
    calling_code: "95",
    currency_code: "MMK",
    currency_name: "Kyat"
    },
    152: {
    txt_id: "na",
    name: "Namibia",
    capital: "Windhoek",
    Continent: "AF",
    top_level_domain: ".na",
    calling_code: "264",
    currency_code: "ZAR",
    currency_name: "Rand"
    },
    153: {
    txt_id: "nr",
    name: "Nauru",
    capital: "Yaren",
    Continent: "OC",
    top_level_domain: ".nr",
    calling_code: "674",
    currency_code: "AUD",
    currency_name: "Australian Dollar"
    },
    154: {
    txt_id: "np",
    name: "Nepal",
    capital: "Kathmandu",
    Continent: "AS",
    top_level_domain: ".np",
    calling_code: "977",
    currency_code: "NPR",
    currency_name: "Nepalese Rupee"
    },
    155: {
    txt_id: "nl",
    name: "Netherlands",
    capital: "Amsterdam",
    Continent: "EU",
    top_level_domain: ".nl",
    calling_code: "31",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    156: {
    txt_id: "nc",
    name: "New Caledonia",
    capital: "Noumea",
    Continent: "OC",
    top_level_domain: ".nc",
    calling_code: "687",
    currency_code: "XPF",
    currency_name: "CFP Franc"
    },
    157: {
    txt_id: "nz",
    name: "New Zealand",
    capital: "Wellington",
    Continent: "OC",
    top_level_domain: ".nz",
    calling_code: "64",
    currency_code: "NZD",
    currency_name: "New Zealand Dollar"
    },
    158: {
    txt_id: "ni",
    name: "Nicaragua",
    capital: "Managua",
    Continent: "NA",
    top_level_domain: ".ni",
    calling_code: "505",
    currency_code: "NIO",
    currency_name: "Cordoba Oro"
    },
    159: {
    txt_id: "ne",
    name: "Niger",
    capital: "Niamey",
    Continent: "AF",
    top_level_domain: ".ne",
    calling_code: "227",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    160: {
    txt_id: "ng",
    name: "Nigeria",
    capital: "Abuja",
    Continent: "AF",
    top_level_domain: ".ng",
    calling_code: "234",
    currency_code: "NGN",
    currency_name: "Naira"
    },
    161: {
    txt_id: "nu",
    name: "Niue",
    capital: "Alofi",
    Continent: "OC",
    top_level_domain: ".nu",
    calling_code: "683",
    currency_code: "NZD",
    currency_name: "New Zealand Dollar"
    },
    162: {
    txt_id: "nf",
    name: "Norfolk Island",
    capital: "Kingston",
    Continent: "OC",
    top_level_domain: ".nf",
    calling_code: "672",
    currency_code: "AUD",
    currency_name: "Australian Dollar"
    },
    163: {
    txt_id: "kp",
    name: "North Korea",
    capital: "Pyongyang",
    Continent: "AS",
    top_level_domain: ".kp",
    calling_code: "850",
    currency_code: "KPW",
    currency_name: "North Korean Won"
    },
    164: {
    txt_id: "mp",
    name: "Northern Mariana Islands",
    capital: "Saipan",
    Continent: "OC",
    top_level_domain: ".mp",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    165: {
    txt_id: "no",
    name: "Norway",
    capital: "Oslo",
    Continent: "EU",
    top_level_domain: ".no",
    calling_code: "47",
    currency_code: "NOK",
    currency_name: "Norwegian Krone"
    },
    166: {
    txt_id: "om",
    name: "Oman",
    capital: "Muscat",
    Continent: "AS",
    top_level_domain: ".om",
    calling_code: "968",
    currency_code: "OMR",
    currency_name: "Rial Omani"
    },
    167: {
    txt_id: "pk",
    name: "Pakistan",
    capital: "Islamabad",
    Continent: "AS",
    top_level_domain: ".pk",
    calling_code: "92",
    currency_code: "PKR",
    currency_name: "Pakistan Rupee"
    },
    168: {
    txt_id: "pw",
    name: "Palau",
    capital: "Melekeok",
    Continent: "OC",
    top_level_domain: ".pw",
    calling_code: "680",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    169: {
    txt_id: "ps",
    name: "Palestine",
    capital: "East Jerusalem",
    Continent: "AS",
    top_level_domain: ".ps",
    calling_code: "970",
    currency_code: "",
    currency_name: "No universal currency"
    },
    170: {
    txt_id: "pa",
    name: "Panama",
    capital: "Panama City",
    Continent: "NA",
    top_level_domain: ".pa",
    calling_code: "507",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    171: {
    txt_id: "pg",
    name: "Papua New Guinea",
    capital: "Port Moresby",
    Continent: "OC",
    top_level_domain: ".pg",
    calling_code: "675",
    currency_code: "PGK",
    currency_name: "Kina"
    },
    172: {
    txt_id: "py",
    name: "Paraguay",
    capital: "Asuncion",
    Continent: "SA",
    top_level_domain: ".py",
    calling_code: "595",
    currency_code: "PYG",
    currency_name: "Guarani"
    },
    173: {
    txt_id: "pe",
    name: "Peru",
    capital: "Lima",
    Continent: "SA",
    top_level_domain: ".pe",
    calling_code: "51",
    currency_code: "PEN",
    currency_name: "Nuevo Sol"
    },
    174: {
    txt_id: "ph",
    name: "Philippines",
    capital: "Manila",
    Continent: "AS",
    top_level_domain: ".ph",
    calling_code: "63",
    currency_code: "PHP",
    currency_name: "Philippine Peso"
    },
    175: {
    txt_id: "pn",
    name: "Pitcairn Islands",
    capital: "Adamstown",
    Continent: "OC",
    top_level_domain: ".pn",
    calling_code: "870",
    currency_code: "NZD",
    currency_name: "New Zealand Dollar"
    },
    176: {
    txt_id: "pl",
    name: "Poland",
    capital: "Warsaw",
    Continent: "EU",
    top_level_domain: ".pl",
    calling_code: "48",
    currency_code: "PLN",
    currency_name: "Zloty"
    },
    177: {
    txt_id: "pt",
    name: "Portugal",
    capital: "Lisbon",
    Continent: "EU",
    top_level_domain: ".pt",
    calling_code: "351",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    178: {
    txt_id: "pr",
    name: "Puerto Rico",
    capital: "San Juan",
    Continent: "NA",
    top_level_domain: ".pr",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    179: {
    txt_id: "qa",
    name: "Qatar",
    capital: "Doha",
    Continent: "AS",
    top_level_domain: ".qa",
    calling_code: "974",
    currency_code: "QAR",
    currency_name: "Qatari Rial"
    },
    180: {
    txt_id: "ro",
    name: "Romania",
    capital: "Bucharest",
    Continent: "EU",
    top_level_domain: ".ro",
    calling_code: "40",
    currency_code: "RON",
    currency_name: "New Romanian Leu"
    },
    181: {
    txt_id: "ru",
    name: "Russia",
    capital: "Moscow",
    Continent: "EU",
    top_level_domain: ".ru",
    calling_code: "7",
    currency_code: "RUB",
    currency_name: "Russian Ruble"
    },
    182: {
    txt_id: "rw",
    name: "Rwanda",
    capital: "Kigali",
    Continent: "AF",
    top_level_domain: ".rw",
    calling_code: "250",
    currency_code: "RWF",
    currency_name: "Rwanda Franc"
    },
    183: {
    txt_id: "re",
    name: "Réunion",
    capital: "Saint-Denis",
    Continent: "AF",
    top_level_domain: ".re",
    calling_code: "262",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    184: {
    txt_id: "ws",
    name: "Samoa",
    capital: "Apia",
    Continent: "OC",
    top_level_domain: ".ws",
    calling_code: "685",
    currency_code: "WST",
    currency_name: "Tala"
    },
    185: {
    txt_id: "sm",
    name: "San Marino",
    capital: "San Marino",
    Continent: "EU",
    top_level_domain: ".sm",
    calling_code: "378",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    186: {
    txt_id: "sa",
    name: "Saudi Arabia",
    capital: "Riyadh",
    Continent: "AS",
    top_level_domain: ".sa",
    calling_code: "966",
    currency_code: "SAR",
    currency_name: "Saudi Riyal"
    },
    187: {
    txt_id: "sn",
    name: "Senegal",
    capital: "Dakar",
    Continent: "AF",
    top_level_domain: ".sn",
    calling_code: "221",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    188: {
    txt_id: "rs",
    name: "Serbia",
    capital: "Belgrade",
    Continent: "EU",
    top_level_domain: ".rs",
    calling_code: "381",
    currency_code: "RSD",
    currency_name: "Serbian Dinar"
    },
    189: {
    txt_id: "sc",
    name: "Seychelles",
    capital: "Victoria",
    Continent: "AF",
    top_level_domain: ".sc",
    calling_code: "248",
    currency_code: "SCR",
    currency_name: "Seychelles Rupee"
    },
    190: {
    txt_id: "sl",
    name: "Sierra Leone",
    capital: "Freetown",
    Continent: "AF",
    top_level_domain: ".sl",
    calling_code: "232",
    currency_code: "SLL",
    currency_name: "Leone"
    },
    191: {
    txt_id: "sg",
    name: "Singapore",
    capital: "Singapore",
    Continent: "AS",
    top_level_domain: ".sg",
    calling_code: "65",
    currency_code: "SGD",
    currency_name: "Singapore Dollar"
    },
    192: {
    txt_id: "sx",
    name: "Sint Maarten",
    capital: "Philipsburg",
    Continent: "NA",
    top_level_domain: ".sx",
    calling_code: "1",
    currency_code: "ANG",
    currency_name: "Netherlands Antillean Guilder"
    },
    193: {
    txt_id: "sk",
    name: "Slovakia",
    capital: "Bratislava",
    Continent: "EU",
    top_level_domain: ".sk",
    calling_code: "421",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    194: {
    txt_id: "si",
    name: "Slovenia",
    capital: "Ljubljana",
    Continent: "EU",
    top_level_domain: ".si",
    calling_code: "386",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    195: {
    txt_id: "sb",
    name: "Solomon Islands",
    capital: "Honiara",
    Continent: "OC",
    top_level_domain: ".sb",
    calling_code: "677",
    currency_code: "SBD",
    currency_name: "Solomon Islands Dollar"
    },
    196: {
    txt_id: "so",
    name: "Somalia",
    capital: "Mogadishu",
    Continent: "AF",
    top_level_domain: ".so",
    calling_code: "252",
    currency_code: "SOS",
    currency_name: "Somali Shilling"
    },
    197: {
    txt_id: "za",
    name: "South Africa",
    capital: "Pretoria",
    Continent: "AF",
    top_level_domain: ".za",
    calling_code: "27",
    currency_code: "ZAR",
    currency_name: "Rand"
    },
    198: {
    txt_id: "gs",
    name: "South Georgia & South Sandwich Islands",
    capital: "Grytviken",
    Continent: "AN",
    top_level_domain: ".gs",
    calling_code: "500",
    currency_code: "",
    currency_name: ""
    },
    199: {
    txt_id: "kr",
    name: "South Korea",
    capital: "Seoul",
    Continent: "AS",
    top_level_domain: ".kr",
    calling_code: "82",
    currency_code: "KRW",
    currency_name: "Won"
    },
    200: {
    txt_id: "ss",
    name: "South Sudan",
    capital: "Juba",
    Continent: "AF",
    top_level_domain: "",
    calling_code: "211",
    currency_code: "SSP",
    currency_name: "South Sudanese Pound"
    },
    201: {
    txt_id: "es",
    name: "Spain",
    capital: "Madrid",
    Continent: "EU",
    top_level_domain: ".es",
    calling_code: "34",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    202: {
    txt_id: "lk",
    name: "Sri Lanka",
    capital: "Colombo",
    Continent: "AS",
    top_level_domain: ".lk",
    calling_code: "94",
    currency_code: "LKR",
    currency_name: "Sri Lanka Rupee"
    },
    203: {
    txt_id: "bl",
    name: "St. Barthélemy",
    capital: "Gustavia",
    Continent: "NA",
    top_level_domain: ".gp",
    calling_code: "590",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    204: {
    txt_id: "sh",
    name: "St. Helena",
    capital: "Jamestown",
    Continent: "AF",
    top_level_domain: ".sh",
    calling_code: "290",
    currency_code: "SHP",
    currency_name: "Saint Helena Pound"
    },
    205: {
    txt_id: "kn",
    name: "St. Kitts & Nevis",
    capital: "Basseterre",
    Continent: "NA",
    top_level_domain: ".kn",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    206: {
    txt_id: "lc",
    name: "St. Lucia",
    capital: "Castries",
    Continent: "NA",
    top_level_domain: ".lc",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    207: {
    txt_id: "mf",
    name: "St. Martin",
    capital: "Marigot",
    Continent: "NA",
    top_level_domain: ".gp",
    calling_code: "590",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    208: {
    txt_id: "pm",
    name: "St. Pierre & Miquelon",
    capital: "Saint-Pierre",
    Continent: "NA",
    top_level_domain: ".pm",
    calling_code: "508",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    209: {
    txt_id: "vc",
    name: "St. Vincent & Grenadines",
    capital: "Kingstown",
    Continent: "NA",
    top_level_domain: ".vc",
    calling_code: "1",
    currency_code: "XCD",
    currency_name: "East Caribbean Dollar"
    },
    210: {
    txt_id: "sd",
    name: "Sudan",
    capital: "Khartoum",
    Continent: "AF",
    top_level_domain: ".sd",
    calling_code: "249",
    currency_code: "SDG",
    currency_name: "Sudanese Pound"
    },
    211: {
    txt_id: "sr",
    name: "Suriname",
    capital: "Paramaribo",
    Continent: "SA",
    top_level_domain: ".sr",
    calling_code: "597",
    currency_code: "SRD",
    currency_name: "Surinam Dollar"
    },
    212: {
    txt_id: "sj",
    name: "Svalbard & Jan Mayen",
    capital: "Longyearbyen",
    Continent: "EU",
    top_level_domain: ".sj",
    calling_code: "47",
    currency_code: "NOK",
    currency_name: "Norwegian Krone"
    },
    213: {
    txt_id: "sz",
    name: "Swaziland",
    capital: "Mbabane",
    Continent: "AF",
    top_level_domain: ".sz",
    calling_code: "268",
    currency_code: "SZL",
    currency_name: "Lilangeni"
    },
    214: {
    txt_id: "se",
    name: "Sweden",
    capital: "Stockholm",
    Continent: "EU",
    top_level_domain: ".se",
    calling_code: "46",
    currency_code: "SEK",
    currency_name: "Swedish Krona"
    },
    215: {
    txt_id: "ch",
    name: "Switzerland",
    capital: "Bern",
    Continent: "EU",
    top_level_domain: ".ch",
    calling_code: "41",
    currency_code: "CHF",
    currency_name: "Swiss Franc"
    },
    216: {
    txt_id: "sy",
    name: "Syria",
    capital: "Damascus",
    Continent: "AS",
    top_level_domain: ".sy",
    calling_code: "963",
    currency_code: "SYP",
    currency_name: "Syrian Pound"
    },
    217: {
    txt_id: "st",
    name: "São Tomé & Príncipe",
    capital: "Sao Tome",
    Continent: "AF",
    top_level_domain: ".st",
    calling_code: "239",
    currency_code: "STD",
    currency_name: "Dobra"
    },
    218: {
    txt_id: "tw",
    name: "Taiwan",
    capital: "Taipei",
    Continent: "AS",
    top_level_domain: ".tw",
    calling_code: "886",
    currency_code: "",
    currency_name: ""
    },
    219: {
    txt_id: "tj",
    name: "Tajikistan",
    capital: "Dushanbe",
    Continent: "AS",
    top_level_domain: ".tj",
    calling_code: "992",
    currency_code: "TJS",
    currency_name: "Somoni"
    },
    220: {
    txt_id: "tz",
    name: "Tanzania",
    capital: "Dodoma",
    Continent: "AF",
    top_level_domain: ".tz",
    calling_code: "255",
    currency_code: "TZS",
    currency_name: "Tanzanian Shilling"
    },
    221: {
    txt_id: "th",
    name: "Thailand",
    capital: "Bangkok",
    Continent: "AS",
    top_level_domain: ".th",
    calling_code: "66",
    currency_code: "THB",
    currency_name: "Baht"
    },
    222: {
    txt_id: "tl",
    name: "Timor-Leste",
    capital: "Dili",
    Continent: "OC",
    top_level_domain: ".tl",
    calling_code: "670",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    223: {
    txt_id: "tg",
    name: "Togo",
    capital: "Lome",
    Continent: "AF",
    top_level_domain: ".tg",
    calling_code: "228",
    currency_code: "XOF",
    currency_name: "CFA Franc BCEAO"
    },
    224: {
    txt_id: "tk",
    name: "Tokelau",
    capital: "",
    Continent: "OC",
    top_level_domain: ".tk",
    calling_code: "690",
    currency_code: "NZD",
    currency_name: "New Zealand Dollar"
    },
    225: {
    txt_id: "to",
    name: "Tonga",
    capital: "Nuku'alofa",
    Continent: "OC",
    top_level_domain: ".to",
    calling_code: "676",
    currency_code: "TOP",
    currency_name: "Pa’anga"
    },
    226: {
    txt_id: "tt",
    name: "Trinidad & Tobago",
    capital: "Port of Spain",
    Continent: "NA",
    top_level_domain: ".tt",
    calling_code: "1",
    currency_code: "TTD",
    currency_name: "Trinidad and Tobago Dollar"
    },
    227: {
    txt_id: "tn",
    name: "Tunisia",
    capital: "Tunis",
    Continent: "AF",
    top_level_domain: ".tn",
    calling_code: "216",
    currency_code: "TND",
    currency_name: "Tunisian Dinar"
    },
    228: {
    txt_id: "tr",
    name: "Turkey",
    capital: "Ankara",
    Continent: "AS",
    top_level_domain: ".tr",
    calling_code: "90",
    currency_code: "TRY",
    currency_name: "Turkish Lira"
    },
    229: {
    txt_id: "tm",
    name: "Turkmenistan",
    capital: "Ashgabat",
    Continent: "AS",
    top_level_domain: ".tm",
    calling_code: "993",
    currency_code: "TMT",
    currency_name: "Turkmenistan New Manat"
    },
    230: {
    txt_id: "tc",
    name: "Turks & Caicos Islands",
    capital: "Cockburn Town",
    Continent: "NA",
    top_level_domain: ".tc",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    231: {
    txt_id: "tv",
    name: "Tuvalu",
    capital: "Funafuti",
    Continent: "OC",
    top_level_domain: ".tv",
    calling_code: "688",
    currency_code: "AUD",
    currency_name: "Australian Dollar"
    },
    232: {
    txt_id: "um",
    name: "U.S. Outlying Islands",
    capital: "",
    Continent: "OC",
    top_level_domain: ".um",
    calling_code: "1",
    currency_code: "",
    currency_name: ""
    },
    233: {
    txt_id: "vi",
    name: "U.S. Virgin Islands",
    capital: "Charlotte Amalie",
    Continent: "NA",
    top_level_domain: ".vi",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar"
    },
    234: {
    txt_id: "gb",
    name: "UK",
    capital: "London",
    Continent: "EU",
    top_level_domain: ".uk",
    calling_code: "44",
    currency_code: "GBP",
    currency_name: "Pound Sterling"
    },
    235: {
    txt_id: "us",
    name: "US",
    capital: "Washington",
    Continent: "NA",
    top_level_domain: ".us",
    calling_code: "1",
    currency_code: "USD",
    currency_name: "US Dollar",
    states: [
    {
    txt_id: "AL",
    name: "Alabama"
    },
    {
    txt_id: "AK",
    name: "Alaska"
    },
    {
    txt_id: "AZ",
    name: "Arizona"
    },
    {
    txt_id: "AR",
    name: "Arkansas"
    },
    {
    txt_id: "CA",
    name: "California"
    },
    {
    txt_id: "CO",
    name: "Colorado"
    },
    {
    txt_id: "CT",
    name: "Connecticut"
    },
    {
    txt_id: "DE",
    name: "Delaware"
    },
    {
    txt_id: "DC",
    name: "District of Columbia"
    },
    {
    txt_id: "FL",
    name: "Florida"
    },
    {
    txt_id: "GA",
    name: "Georgia"
    },
    {
    txt_id: "HI",
    name: "Hawaii"
    },
    {
    txt_id: "ID",
    name: "Idaho"
    },
    {
    txt_id: "IL",
    name: "Illinois"
    },
    {
    txt_id: "IN",
    name: "Indiana"
    },
    {
    txt_id: "IA",
    name: "Iowa"
    },
    {
    txt_id: "KS",
    name: "Kansas"
    },
    {
    txt_id: "KY",
    name: "Kentucky"
    },
    {
    txt_id: "LA",
    name: "Louisiana"
    },
    {
    txt_id: "ME",
    name: "Maine"
    },
    {
    txt_id: "MT",
    name: "Montana"
    },
    {
    txt_id: "NE",
    name: "Nebraska"
    },
    {
    txt_id: "NV",
    name: "Nevada"
    },
    {
    txt_id: "NH",
    name: "New Hampshire"
    },
    {
    txt_id: "NJ",
    name: "New Jersey"
    },
    {
    txt_id: "NM",
    name: "New Mexico"
    },
    {
    txt_id: "NY",
    name: "New York"
    },
    {
    txt_id: "NC",
    name: "North Carolina"
    },
    {
    txt_id: "ND",
    name: "North Dakota"
    },
    {
    txt_id: "OH",
    name: "Ohio"
    },
    {
    txt_id: "OK",
    name: "Oklahoma"
    },
    {
    txt_id: "OR",
    name: "Oregon"
    },
    {
    txt_id: "MD",
    name: "Maryland"
    },
    {
    txt_id: "MA",
    name: "Massachusetts"
    },
    {
    txt_id: "MI",
    name: "Michigan"
    },
    {
    txt_id: "MN",
    name: "Minnesota"
    },
    {
    txt_id: "MS",
    name: "Mississippi"
    },
    {
    txt_id: "MO",
    name: "Missouri"
    },
    {
    txt_id: "PA",
    name: "Pennsylvania"
    },
    {
    txt_id: "RI",
    name: "Rhode Island"
    },
    {
    txt_id: "SC",
    name: "South Carolina"
    },
    {
    txt_id: "SD",
    name: "South Dakota"
    },
    {
    txt_id: "TN",
    name: "Tennessee"
    },
    {
    txt_id: "TX",
    name: "Texas"
    },
    {
    txt_id: "UT",
    name: "Utah"
    },
    {
    txt_id: "VT",
    name: "Vermont"
    },
    {
    txt_id: "VA",
    name: "Virginia"
    },
    {
    txt_id: "WA",
    name: "Washington"
    },
    {
    txt_id: "WV",
    name: "West Virginia"
    },
    {
    txt_id: "WI",
    name: "Wisconsin"
    },
    {
    txt_id: "WY",
    name: "Wyoming"
    }
    ]
    },
    236: {
    txt_id: "ug",
    name: "Uganda",
    capital: "Kampala",
    Continent: "AF",
    top_level_domain: ".ug",
    calling_code: "256",
    currency_code: "UGX",
    currency_name: "Uganda Shilling"
    },
    237: {
    txt_id: "ua",
    name: "Ukraine",
    capital: "Kiev",
    Continent: "EU",
    top_level_domain: ".ua",
    calling_code: "380",
    currency_code: "UAH",
    currency_name: "Hryvnia"
    },
    238: {
    txt_id: "ae",
    name: "United Arab Emirates",
    capital: "Abu Dhabi",
    Continent: "AS",
    top_level_domain: ".ae",
    calling_code: "971",
    currency_code: "AED",
    currency_name: "UAE Dirham"
    },
    239: {
    txt_id: "uy",
    name: "Uruguay",
    capital: "Montevideo",
    Continent: "SA",
    top_level_domain: ".uy",
    calling_code: "598",
    currency_code: "UYU",
    currency_name: "Peso Uruguayo"
    },
    240: {
    txt_id: "uz",
    name: "Uzbekistan",
    capital: "Tashkent",
    Continent: "AS",
    top_level_domain: ".uz",
    calling_code: "998",
    currency_code: "UZS",
    currency_name: "Uzbekistan Sum"
    },
    241: {
    txt_id: "vu",
    name: "Vanuatu",
    capital: "Port Vila",
    Continent: "OC",
    top_level_domain: ".vu",
    calling_code: "678",
    currency_code: "VUV",
    currency_name: "Vatu"
    },
    242: {
    txt_id: "va",
    name: "Vatican City",
    capital: "Vatican City",
    Continent: "EU",
    top_level_domain: ".va",
    calling_code: "379",
    currency_code: "EUR",
    currency_name: "Euro"
    },
    243: {
    txt_id: "ve",
    name: "Venezuela",
    capital: "Caracas",
    Continent: "SA",
    top_level_domain: ".ve",
    calling_code: "58",
    currency_code: "VEF",
    currency_name: "Bolivar"
    },
    244: {
    txt_id: "vn",
    name: "Vietnam",
    capital: "Hanoi",
    Continent: "AS",
    top_level_domain: ".vn",
    calling_code: "84",
    currency_code: "VND",
    currency_name: "Dong"
    },
    245: {
    txt_id: "wf",
    name: "Wallis & Futuna",
    capital: "Mata Utu",
    Continent: "OC",
    top_level_domain: ".wf",
    calling_code: "681",
    currency_code: "XPF",
    currency_name: "CFP Franc"
    },
    246: {
    txt_id: "eh",
    name: "Western Sahara",
    capital: "El-Aaiun",
    Continent: "AF",
    top_level_domain: ".eh",
    calling_code: "212",
    currency_code: "MAD",
    currency_name: "Moroccan Dirham"
    },
    247: {
    txt_id: "ye",
    name: "Yemen",
    capital: "Sanaa",
    Continent: "AS",
    top_level_domain: ".ye",
    calling_code: "967",
    currency_code: "YER",
    currency_name: "Yemeni Rial"
    },
    248: {
    txt_id: "zm",
    name: "Zambia",
    capital: "Lusaka",
    Continent: "AF",
    top_level_domain: ".zm",
    calling_code: "260",
    currency_code: "ZMW",
    currency_name: "Zambian Kwacha"
    },
    249: {
    txt_id: "zw",
    name: "Zimbabwe",
    capital: "Harare",
    Continent: "AF",
    top_level_domain: ".zw",
    calling_code: "263",
    currency_code: "ZWL",
    currency_name: "Zimbabwe Dollar"
    },
    250: {
    txt_id: "ax",
    name: "Åland Islands",
    capital: "Mariehamn",
    Continent: "EU",
    top_level_domain: ".ax",
    calling_code: "358",
    currency_code: "EUR",
    currency_name: "Euro"
    }
  }
}

module.exports = countries
